import { call, select, put } from 'redux-saga/effects';
import API from "../../API";
import {
  loadHbIndexError,
  loadHbIndexSuccess,
  loadSentimentBreakdownError,
  loadSentimentBreakdownSuccess
} from "./charts-action-creators";
import {loadSentimentBreakdownToFullReport} from "../full-report-primary-or-sentiment/full-report-primary-or-sentiment-action-creators";


export function* loadSentimentBreakdown() {
  const reportUrl = yield select(state => state.report.reportUrl);
  const filters = yield select(state => state.filters.filtersToSend);
  try {
    const result = yield call(API.loadSentimentBreakdown, { reportUrl, filters});
    console.log(filters, 'FILTERS FROM LOAD SENTIMENT BREAKDOWN');
    console.log(result, 'RESULT FROM LOAD SENTIMENT BREAKDOWN');

    if (result.data.results && result.data.results.length) {
      const sentimentBreakdown = normalizeSentimentBreakdown(result.data.results);
      yield put(loadSentimentBreakdownSuccess(sentimentBreakdown));
      yield put(loadSentimentBreakdownToFullReport(sentimentBreakdown));
    } else {
      yield put(loadSentimentBreakdownError("No data"));
    }

    if (result.data && result.data.hb_index) {
      yield put(loadHbIndexSuccess(result.data.hb_index));
    } else {
      yield put(loadHbIndexError("No data"));
    }

  } catch(error) {
    console.log(error, 'ERROR FROM LOAD SENTIMENT BREAKDOWN');
    yield put(loadSentimentBreakdownError("Something went wrong..."));
    yield put(loadHbIndexError("Something went wrong..."));
  }
}

const normalizeSentimentBreakdown = data => {
  const total = data.reduce((acc, current) => {
    acc += current.count;
    return acc;
  }, 0);
  return data.map(d => {
    d.percent = Number(d.count / total * 100).toFixed(1);
    d.sentiment === "Neutral" ? d.sentiment = "Void" : null;
    return d;
  });
};





// WEBPACK FOOTER //
// ./src/modules/charts/load-sentiment-breakdown-saga.js